import React from 'react';
import { Box } from '@mui/material';
import ModalWidget from 'widgets/modal/Modal';
import CustomButton from 'shared/custom-button/CustomButton';
import styles from 'widgets/modal-answer/ModalAnswer.module.css';
import { useNavigate } from 'react-router-dom';
import { RoutesType } from 'shared/types/routes/routers-type';

interface IModalAnswer {
    open: boolean;
    handleClose: () => void;
    numberBill: string;
    idBill: string;
}

const ModalAnswer: React.FC<IModalAnswer> = ({
    open,
    handleClose,
    numberBill,
    idBill

}) => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(`${RoutesType.TaskCase}/?id=${idBill}`, {
            state: {
                textRout: 'applications',
                name: 'Заявки'
            }
        });

    }
    return (
        <ModalWidget
            open={open}
            handleClose={handleClose}
            title=""
            closeIconPosition="right"
            onAccept={handleClose}
        >
            <Box>
                <p>Ваша заявка успешно отправлена!</p>
                <p>Заявка <span className={styles.numberBill}>{numberBill}</span> уже в работе.</p>
                <p>Статус исполнения заявки можно посмотреть в разделе "Заявки"</p>
                <Box>
                    <CustomButton
                        handleClick={handleClick}
                        title='Перейти к заявке'
                        textColor="white"
                        backgroundColor="#0054E6"
                        padding="5px 30px"
                        gap="10px"
                        border='none'
                        borderRadius='4px'

                    />
                </Box>
            </Box>
        </ModalWidget>
    );
};

export default ModalAnswer;